import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { apiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";

export const DigestPanel = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const run = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/insights/digest");
      setResult(data);
    } catch (e) {
      toast.error(apiErrorDetail(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="widget p-6 bg-blue-950/20 border-primary/20" data-testid="digest-panel">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-primary" />
          <h2 className="font-heading font-bold text-lg text-white tracking-tight">Your AI portfolio digest</h2>
        </div>
        {result && (
          <span className="text-[11px] font-mono text-muted-foreground">
            {result.cached ? "CACHED · " : "FRESH · "}{new Date(result.generated_at).toLocaleString()}
          </span>
        )}
      </div>
      <p className="text-sm text-muted-foreground mt-1 mb-4">
        A personal round-up of your portfolio's day, triggered alerts and current screen matches.
      </p>
      {!result ? (
        <Button onClick={run} disabled={loading} className="rounded-sm bg-primary hover:bg-primary/85 text-white" data-testid="digest-button">
          {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Writing digest…</> : <><Sparkles className="w-4 h-4 mr-2" /> Generate my digest</>}
        </Button>
      ) : (
        <div className="space-y-2 fade-up" data-testid="digest-content">
          {result.digest.split("\n").map((line, i) => (
            <p key={i} className={`text-sm text-gray-100 leading-relaxed ${line.trim().startsWith("- ") ? "pl-3" : ""}`}>
              {line || "\u00a0"}
            </p>
          ))}
        </div>
      )}
      <p className="text-xs text-muted-foreground mt-5 pt-3 border-t border-white/10">
        This is AI-generated research, not financial advice.
      </p>
    </div>
  );
};
